const parsePhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return undefined;

  const formattedPhoneNumber = phoneNumber.phone_number.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
  const ext = phoneNumber.extension ? ` ext. ${phoneNumber.extension}` : '';

  return `${formattedPhoneNumber}${ext}`;
};

export const phoneNumberBackfill = (closestLocation, programPhoneNumbers, organization) => {
  let phoneNumbers = [];
  if (closestLocation?.phone_numbers?.length) {
    phoneNumbers = closestLocation.phone_numbers;
  } else if (programPhoneNumbers && programPhoneNumbers.length) {
    phoneNumbers = programPhoneNumbers;
  } else {
    phoneNumbers = organization.phone_numbers;
  }
  const nonFaxNumbers = phoneNumbers.filter((number) => number.phone_type !== 'fax');
  const phoneNumber = nonFaxNumbers.find((number) => number.is_primary) || nonFaxNumbers[0];
  return parsePhoneNumber(phoneNumber);
};

export const emailBackfill = (closestLocation, programEmails, organization) => {
  let emails = [];
  if (closestLocation?.email_addresses?.length) {
    emails = closestLocation.email_addresses;
  } else if (programEmails && programEmails.length) {
    emails = programEmails;
  } else {
    emails = organization.email_addresses || [];
  }
  const email = emails.find((address) => address.is_primary) || emails[0] || undefined;
  return typeof email === 'string' ? email : email?.email_address || '';
};

export const websiteBackfill = (programWebsite, organization) => {
  if (programWebsite) {
    return programWebsite;
  } if (organization && organization.website_url) {
    return organization.website_url;
  }
  return '';
};

export const hoursBackfill = (closestLocation, organization) => {
  if (closestLocation && closestLocation.hours) {
    return closestLocation.hours;
  } if (organization && organization.hours) {
    return organization.hours;
  }
  return {};
};
